import React, { Fragment, useState, useEffect } from "react";
import { Typography, Box, Grid } from "@mui/material";
import colors from "../../../styles/colors";
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import { InputField } from "../../../components/Fields/TextField";
import { PrimaryButton } from "../../../components/Button/Button";
import {
  ErrorToaster,
  SuccessToaster,
} from "../../../components/Toaster/Toaster";
import OffersServices from "../../../apis/Marketplace/Offers/OffersServices";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";

function EditOffer() {
  const [loading, setLoading] = useState(false);
  const [color, setColor] = useState("#aabbcc");
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const { state } = useLocation();

  const updateOffer = async (formData) => {
    setLoading(true);
    try {
      let obj = {
        id: state?.data?._id,
        name: formData.offer,
        name_ar: formData.offerInAr,
        color: formData.color,
      };
      const { data, message } = await OffersServices.updateOffer(obj);
      if (data === null) return;
      setTimeout(() => navigate("/marketplace/Offers"), 1000);
      SuccessToaster(message);
    } catch (error) {
      ErrorToaster(error);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const defaulData = () => {
    setValue("offer", state?.data?.name);
    setValue("offerInAr", state?.data?.name_ar);
    setValue("color", state?.data?.color);
  };

  useEffect(() => {
    defaulData();
  }, []);

  return (
    <Fragment>
      {/* <ColorDialog open={colorDialog} onClose={() => setColorDialog(false)} /> */}
      <Box
        sx={{
          backgroundColor: colors.lightGray,
          p: 3,
          borderRadius: "12px",
          // width: "calc(100vw - 370px)",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ bgcolor: colors.white, p: 2, borderRadius: "12px" }}
        >
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">
              Edit Offer
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Offers", "Edit Offer"]} />
          </Grid>
        </Grid>
        <Box sx={{ bgcolor: colors.white, p: 3, borderRadius: "12px", mt: 2 }}>
          <Typography component={"form"} onSubmit={handleSubmit(updateOffer)}>
            <Grid container spacing={2} alignItems="center">
              {/* Name in Eng */}
              <Grid item xs={12} md={6}>
                <InputField
                  label="Create Offer"
                  register={register("offer", {
                    required: "Please fill the field",
                  })}
                  error={errors?.offer?.message}
                />
              </Grid>
              {/* Name in Ar */}
              <Grid item xs={12} md={6}>
                <InputField
                  sx={{ direction: "rtl" }}
                  label="إنشاء العرض"
                  register={register("offerInAr", {
                    required: "Please fill the field",
                  })}
                  error={errors?.offerInAr?.message}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <InputField
                  label={"Select Color"}
                  type={"color"}
                  defaultValue={getValues("color")}
                  onChange={(e) => {
                    setColor(e.target.value);
                  }}
                  register={register("color", {
                    required: "Please select color",
                  })}
                  error={errors?.offer?.message}
                />
              </Grid>
            </Grid>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PrimaryButton
                data-testId="save-btn"
                title={"Update"}
                type="submit"
                loading={loading}
              />
            </Box>
          </Typography>
        </Box>
      </Box>
    </Fragment>
  );
}

export default EditOffer;
